import { __cCommunityThreads } from '@/services/client/__c.community-threads.service'
import { useQuery } from '@tanstack/react-query'

export const useCommunityThreads = () => {
  return useQuery({
    queryKey: ['community-threads'],
    queryFn: () => __cCommunityThreads.getCommunityThreads(),
  })
}
